module.exports = new __parcel__URL__("mirewood-house.80b3f809.webp").toString();